export var SUCCESS_MSG = {
    message: 'Changes saved',
};
export var PRO_ALLOWANCE_DISABLED_SUCCESS_MSG = {
    message: 'Allowance Now Disabled',
};
export var PRO_ALLOWANCE_DELETED_SUCCESS_MSG = {
    message: 'Allowance Deleted',
};
export var HAVE_NOT_CREATED_PRO_ALLOWANCES_MSG = {
    message: "You haven't created any Pro Allowances.",
};
export var CREATE_PRO_ALLOWANCE_MSG = {
    message: 'Create a Pro Allowance to keep jobs on budget and save time at checkout.',
};
